import { M_BEACON_INFO, type MatrixEvent, type MatrixClient } from "matrix-js-sdk/src/matrix";

import { getShareableLocationEventForBeacon } from "../../utils/beacon/getShareableLocation";
import { isLocationEvent } from "../../utils/EventUtils";

/**
 * Get event that is shareable as a location
 * If an event does not have a shareable location, return null
 */
export const getShareableLocationEvent = (event: MatrixEvent, cli: MatrixClient): MatrixEvent | null => {
    if (isLocationEvent(event)) {
        return event;
    }

    if (M_BEACON_INFO.matches(event.getType())) {
        return getShareableLocationEventForBeacon(event, cli);
    }
    return null;
};
